// src/pages/NotificationHistory/NotificationHistoryPage.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import NotificationHistory from '../../components/NotificationHistory/NotificationHistory';

const NotificationHistoryPage = () => {
    return (
        <>
            <Helmet>
                <title>Historial de Notificaciones - PetitPrime</title>
                <meta name="description" content="Revisa el historial y estado de todas las notificaciones enviadas" />
            </Helmet>

            <div className="container mx-auto px-4 py-8">
                <NotificationHistory />
            </div>
        </>
    );
};

export default NotificationHistoryPage; 